export const FETCH_MERCHANDISING = "FETCH_MERCHANDISING";
export const FETCH_MERCHANDISING_REQUEST = "FETCH_MERCHANDISING_REQUEST";
export const FETCH_MERCHANDISING_SUCCESS = "FETCH_MERCHANDISING_SUCCESS";
export const FETCH_MERCHANDISING_FAILURE = "FETCH_MERCHANDISING_FAILURE";
export const SET_MERCH_PRODUCTS_FILTER_BY = "SET_MERCH_PRODUCTS_FILTER_BY";
export const UPDATE_CURRENT_MERCH_CODE = "UPDATE_CURRENT_MERCH_CODE";
export const UNSET_MERCH_PRODUCTS_FILTER_BY = "UNSET_MERCH_PRODUCTS_FILTER_BY";
export const UPDATE_MERCH_PREVIEW_START_DATE = "UPDATE_MERCH_PREVIEW_START_DATE";
